var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{class:_vm.isOnline(_vm.userId),attrs:{"size":_vm.size,"title":_vm.getEmailForUser(_vm.userId)}},[(_vm.avatar)?[_c('v-img',{attrs:{"src":_vm.avatar,"alt":_vm.formatUserLetters(_vm.userId)}})]:_vm._e(),(!_vm.avatar)?[_c('span',[_vm._v(_vm._s(_vm.formatUserLetters(_vm.userId)))])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }